<template>
  <div id="app" class="container">
    <div class="row">
      <div class="col-12" style="text-align: center">
        <img src="@/assets/logo_512.png" width="150" />
        <br /><br />

        <font style="font-size: 24pt; color: #333">實價好好查</font><br />
        <font style="font-size: 14pt; color: #666">最好用的實價登錄地圖</font>
        <br /><br />

        <div class="row" style="line-height: 36px">
          <div class="col-12">☑ 直覺好用地圖操作</div>
          <div class="col-12">☑ 路名地址查詢位置</div>
          <div class="col-12">☑ 關注社區成交通知</div>
          <div class="col-12">☑ 小範圍統計與分析</div>
          <div class="col-12">☑ 成交條件精準篩選</div>
        </div>

        <br />

        <div>
          <a
            href="https://play.google.com/store/apps/details?id=com.bstudio.realprice&utm_source=landing-page&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
            ><img
              width="185"
              alt="Google Play"
              src="@/assets/download-on-google-play.png"
          /></a>
        </div>

        <div style="padding: 12px">
          <a
            href="https://apps.apple.com/tw/app/%E5%AF%A6%E5%83%B9%E5%A5%BD%E5%A5%BD%E6%9F%A5/id1523425827"
            ><img
              width="161"
              alt="App Store"
              src="@/assets/download-on-app-store.png"
          /></a>
        </div>

        <br /><br />
      </div>

      <div class="col-12">
        <center>
          <img
            alt="Screenshot"
            src="@/assets/screenshot.png"
            style="
              border-radius: 10px;
              filter: drop-shadow(4px 4px 4px rgba(0, 0, 0, 0.4));
            "
          />
        </center>

        <br /><br />
      </div>

      <div class="col-12">
        <center>
          <h2>推薦文章</h2>

          <div style="width: 360px; text-align: left">
          
            <div class="review-item">
              <li>
                <a
                  href="https://bigbenthings.com/app-lookup-house-price/"
                  target="_blank"
                >
                  實價好好查 – 用更直覺的方式查詢房價
                </a>
              </li>
              <span>大班哥的事 2021/10/24</span>
            </div>

            <div class="review-item">
              <li>
                <a
                  href="https://www.soft4fun.net/mobile/android-relate/bstudio-realprice.htm"
                  target="_blank"
                >
                  拒當盤子！房價行情一目瞭然，史上最好用的實價登錄分析工具「實價好好查」
                </a>
              </li>
              <span>硬是要學 2020/8/13</span>
            </div>

            <div class="review-item">
              <li>
                <a href="https://briian.com/59539/" target="_blank"
                  >「實價登錄地圖」超直覺好用的房屋交易行情查詢工具</a
                >
              </li>
              <span>重灌狂人 2019/5/27</span>
            </div>

            <br /><br />
          </div>
        </center>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
};
</script>

<style>
#app {
  padding-top: 40px;
}

.review-item {
  padding: 10px;
}

.review-item > span {
  color: #333;
}
</style>